import React from "react"
import { Button, Row, Image } from "antd"

const AppHeader = ({
  onRemoveUserToken,
  userName,
}: {
  onRemoveUserToken: any
  userName: string | null
}) => {
  return (
    <Row
      style={{
        padding: "0 10px",
        display: "flex",
        flex: 1,
        position: "fixed",
        top: 0,
        width: "100%",
        justifyContent: "space-between",
        backgroundColor: "white",
        zIndex: 50,
        alignItems: "center",
        height: 90,
        opacity: ".97",
        // borderBottom: '1px solid #EEE',
      }}
    >
      <Image
        src={
          "https://aurin.org.au/wp-content/uploads/2018/07/aurin-logo-400.png"
        }
        style={{ cursor: "pointer" }}
        width={180}
        preview={false}
        alt={"AURIN logo"}
      />
      <div>
        <Button
          style={{
            marginLeft: 10,
          }}
          type={"primary"}
          size={"small"}
          onClick={onRemoveUserToken}
        >
          Logout
        </Button>
      </div>
    </Row>
  )
}

export default AppHeader
